function sbfSortByWeight(root) {
  root.querySelectorAll('.sbf-cards').forEach(function(list) {
    Array.from(list.children)
      .sort(function(a, b) { return (parseFloat(a.dataset.sbfWeightGrams || '0') || 0) - (parseFloat(b.dataset.sbfWeightGrams || '0') || 0); })
      .forEach(function(item, index) { list.appendChild(item); item.classList.toggle('is-active', index === 0); });
  });
  root.querySelectorAll('.sbf-table tbody').forEach(function(tbody) {
    Array.from(tbody.children)
      .sort(function(a, b) { return (parseFloat(a.dataset.sbfWeightGrams || '0') || 0) - (parseFloat(b.dataset.sbfWeightGrams || '0') || 0); })
      .forEach(function(row) { tbody.appendChild(row); });
  });
}

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.sb-formatos').forEach(sbfSortByWeight);
});

document.addEventListener('click', function(event) {
  const tab = event.target.closest('[data-sbf-tab]');
  if (tab) {
    const section = tab.closest('.sb-formatos');
    const id = tab.getAttribute('data-sbf-tab');
    if (!section || !id) return;

    section.querySelectorAll('[data-sbf-tab]').forEach(function(button) {
      const active = button === tab;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    section.querySelectorAll('[data-sbf-panel]').forEach(function(panel) {
      panel.classList.toggle('is-active', panel.getAttribute('data-sbf-panel') === id);
    });
  }

  const protein = event.target.closest('[data-sbf-protein]');
  if (protein) {
    const panel = protein.closest('[data-sbf-panel]');
    const id = protein.getAttribute('data-sbf-protein');
    if (!panel || !id) return;

    panel.querySelectorAll('[data-sbf-protein]').forEach(function(button) {
      const active = button === protein;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    panel.querySelectorAll('[data-sbf-protein-panel]').forEach(function(proteinPanel) {
      proteinPanel.classList.toggle('is-active', proteinPanel.getAttribute('data-sbf-protein-panel') === id);
    });
  }

  const card = event.target.closest('[data-sbf-card]');
  if (card) {
    const holder = card.closest('.sbf-cards');
    if (!holder) return;
    holder.querySelectorAll('[data-sbf-card]').forEach(function(item) {
      item.classList.toggle('is-active', item === card);
    });
  }
});
